import {
  createEntityAdapter,
  createSelector,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';

import { RootState } from 'src/store/index';
import dayjs from 'src/libs/dayjs';

export type State = {
  loading: boolean;
};

export const adapter = createEntityAdapter<Model.HomeworkComment>({
  selectId: (model) => model.id,
});

const { reducer, actions } = createSlice({
  name: 'homework_reply_comment',
  initialState: adapter.getInitialState<State>({ loading: false }),
  reducers: {
    updateEntities(state, action: PayloadAction<Model.HomeworkComment[]>) {
      adapter.upsertMany(state, action);
    },
    updateEntity(state, action: PayloadAction<Model.HomeworkComment>) {
      adapter.removeOne(state, 'placeholder');
      adapter.upsertOne(state, action);
    },
    removeEntity(state, action: PayloadAction<Model.HomeworkComment>) {
      adapter.removeOne(state, action.payload.id);
    },
    updateLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    createDummy(state, action: PayloadAction<Partial<Model.HomeworkComment>>) {
      adapter.upsertOne(state, {
        total_comments: 0,
        id: 'placeholder',
        // comments: [],
        created_at: '',
        parent_id: action.payload.parent_id || null,
        updated_at: '',
        user_id: action.payload.user_id!,
        class_topic_id: action.payload.class_topic_id!,
        user_assignment_file_id: action.payload.user_assignment_file_id!,
        message: action.payload.message!,
        user: action.payload.user!,
      });
    },
  },
});

export const selector = adapter.getSelectors(
  (state: RootState) => state.model.homework_reply_comment,
);

export const selectHomeworkReplyComments = createSelector(
  selector.selectAll,
  (state: RootState, parent_id: string) => parent_id,
  (replies, parent_id) => {
    const results = replies.filter((c) => c.parent_id === parent_id);

    return results.sort((a, b) =>
      dayjs(a.created_at).isBefore(dayjs(b.created_at)) ? -1 : 1,
    );
  },
);

export { reducer };
export default actions;
